/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Col_TierInputs */

const en_fw_bm_col_tier = /** @type {(inputs: Fw_Bm_Col_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tier`)
};

const id_fw_bm_col_tier = /** @type {(inputs: Fw_Bm_Col_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat`)
};

/**
* | output |
* | --- |
* | "Tier" |
*
* @param {Fw_Bm_Col_TierInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_col_tier = /** @type {((inputs?: Fw_Bm_Col_TierInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Col_TierInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_col_tier(inputs)
	return en_fw_bm_col_tier(inputs)
});